(function()
{
	function Device()
	{
		this.OS = {
			kindle: false,
			android: false,
			chromeOS: false,
			iOS: false,
			iOSVersion: 0,
			linux: false,
			macOS: false,
			windowsPhone: false,
			windows: false
		};

		//  Browser
		this.browsers = {
			cocoonJS: false,
			cordova: false,
			chrome: false,
			chromeVersion: 0,
			firefox: false,
			firefoxVersion: 0,
			ie: false,
			ieVersion: 0,
			ieEdge: false,
			mobileSafari: false,
			opera: false,
			safari: false,
			safariVersion: 0,
			webApp: false,
			silk: false
		};

		//  Audio
		this.audio = {
			audioTags: false,
			webAudio: false,
			ogg: false,
			opus: false,
			mp3: false,
			wav: false,
			m4a: false,
			webm: false,
			dolby: false
		};

		//  Video
		this.video = {
			oggVideo: false,
			h264Video: false,
			mp4Video: false,
			webmVideo: false,
			vp9Video: false,
			hlsVideo: false
		};

		//  Device
		this.desktop = false;
		this.mobile = false;
		this.iPhone = false;
		this.iPhone4 = false;
		this.iPad = false;
		this.iPad2 = false;
		this.pixelRatio = 0;
		this.file = false;
		this.fileSystem = false;
		this.localStorage = false;
		this.worker = false;
		this.vibration = false;
		this.touch = false;
		this.fullscreen = false;
		this.fullscreenKeyboard = false;

		this.requestFullscreen = '';
		this.cancelFullscreen = '';

		this.performChecks();
	}

	var p = Device.prototype;

	p.performChecks = function()
	{
		this.checkOS();
		this.checkBrowser();
		this.checkDevice();
	};

	p.checkOS = function()
	{
		var ua = navigator.userAgent;

		this.OS.kindle = /Kindle/.test(ua) || /\bKF[A-Z][A-Z]+/.test(ua) || /Silk/.test(ua);
		this.OS.android = /Android/.test(ua);
		this.OS.chromeOS = /CrOS/.test(ua);
		this.OS.iOS = /iP[ao]d|iPhone/i.test(ua);
		this.OS.linux = /Linux/.test(ua);
		this.OS.macOS = /Mac OS/.test(ua);
		this.OS.windowsPhone = /Windows Phone/i.test(ua) || /IEMobile/i.test(ua);
		this.OS.windows = this.OS.windowsPhone || /Windows/.test(ua);

		if (this.OS.iOS || this.OS.android)
		{
			this.mobile = true;
		}

		if (!this.mobile && (this.OS.windows || this.OS.macOS || (this.OS.linux && !this.kindle) || this.OS.chromeOS))
		{
			this.desktop = true;
		}

		if (this.OS.iOS)
		{
			(navigator.appVersion).match(/OS (\d+)/);
			this.OS.iOSVersion = parseInt(RegExp.$1, 10);
		}

		this.mobile = !this.desktop;
	};

	p.checkBrowser = function()
	{
		var ua = navigator.userAgent;
		var bwrs = this.browsers;
		var OS = this.OS;

		if (/Edge\/\d+/.test(ua))
		{
			bwrs.edge = true;
		}
		else if (/Chrome\/(\d+)/.test(ua) && !OS.windowsPhone)
		{
			bwrs.chrome = true;
			bwrs.chromeVersion = parseInt(RegExp.$1, 10);
		}
		else if (/Firefox\D+(\d+)/.test(ua))
		{
			bwrs.firefox = true;
			bwrs.firefoxVersion = parseInt(RegExp.$1, 10);
		}
		else if (/AppleWebKit/.test(ua) && OS.iOS)
		{
			bwrs.mobileSafari = true;
		}
		else if (/MSIE (\d+\.\d+);/.test(ua))
		{
			bwrs.ie = true;
			bwrs.ieVersion = parseInt(RegExp.$1, 10);
		}
		else if (/Opera/.test(ua))
		{
			bwrs.opera = true;
		}
		else if (/Safari\/(\d+)/.test(ua) && !OS.windowsPhone)
		{
			bwrs.safari = true;

			if (/Version\/(\d+)\./.test(ua))
			{
				bwrs.safariVersion = parseInt(RegExp.$1, 10);
			}
		}

		//  Silk gets its own if clause because its ua also contains 'Safari'
		if (/Silk/.test(ua))
		{
			bwrs.silk = true;
		}

		//  WebApp mode in iOS
		if (navigator.standalone)
		{
			bwrs.webApp = true;
		}

		if (typeof window.cordova !== 'undefined')
		{
			bwrs.cordova = true;
		}

		if (navigator.isCocoonJS)
		{
			bwrs.cocoonJS = true;
		}
	};

	p.checkDevice = function()
	{
		var ua = navigator.userAgent;

		this.pixelRatio = window.devicePixelRatio || 1;
		this.iPhone = ua.toLowerCase().indexOf('iphone') !== -1;
		this.iPhone4 = (this.pixelRatio === 2 && this.iPhone);
		this.iPad = ua.toLowerCase().indexOf('ipad') !== -1;
		this.iPad2 = this.iPad && this.pixelRatio === 1;

		this.vibration = !!(navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate);

		//Test for localStorage
		try
		{
			var k = "DC"; //test key
			localStorage.setItem(k, k);
			localStorage.removeItem(k);
			this.features.localStorage = true;
		}
		catch (e)
		{}


		this.file = !!(window.File && window.FileList && window.FileReader);
		this.fileSystem = !!window.requestFileSystem;
		this.worker = !!window.Worker;
		this.touch = ('ontouchstart' in document.documentElement || (window.navigator.maxTouchPoints && window.navigator.maxTouchPoints >= 1));

		this.audioTags = !!(window.Audio);
		this.webAudio = !!(window.AudioContext || window.webkitAudioContext);
	};

	cm.Device = new Device();
})();